export class ListCalendarLock {
    cerraduras: number[] = [];
    calendarios: number[] = [];
    empresaId: number;
}
